import { forwardRef, HTMLAttributes } from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { ReactComponent as OpenInNewSVG } from '@/assets/icons-2.0/open_in_new.svg';

const TAX_BASE_LINK = 'https://tasnif.soliq.uz';

type CustomListBoxProps = HTMLAttributes<HTMLElement> & {
  loading: boolean;
  searchQuery: string;
};

export const CustomListBox = forwardRef<HTMLDivElement, CustomListBoxProps>((props, ref) => {
  const { loading, searchQuery = '', ...restOfProps } = props;
  return (
    <div
      ref={ref}
      {...restOfProps}
      style={{
        ...restOfProps.style,
        padding: 0,
      }}
    >
      {loading && (
        <Box py={2} px={2}>
          Загрузка...
        </Box>
      )}

      {!loading && (
        <>
          <Box
            sx={{
              borderBottom: theme => theme.shape.divider,
              backgroundColor: theme => theme.palette.neutral['200'],
            }}
            px={2}
            py={1}
            position="sticky"
            top={0}
            zIndex={1}
          >
            <Typography variant="Body/medium" color="neutral.700">
              Поиск по названию, штрих-коду или ИКПУ
            </Typography>
          </Box>

          <ul>{restOfProps.children}</ul>

          <Stack
            sx={{
              borderTop: theme => theme.shape.divider,
              backgroundColor: theme => theme.palette.neutral['200'],
            }}
            direction="row"
            justifyContent="space-between"
            px={2}
            py={1}
            position="sticky"
            bottom={0}
            zIndex={1}
          >
            <Typography variant="Body/medium" color="neutral.700">
              Не нашли нужный товар?
            </Typography>
            <Link href={`${TAX_BASE_LINK}/search-deep?search=${searchQuery}`} target="_blank" underline="none">
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Typography variant="Body/medium">Открыть базу налоговой</Typography>
                <OpenInNewSVG width={16} height={16} />
              </Stack>
            </Link>
          </Stack>
        </>
      )}
    </div>
  );
});
